  function setupGridHoverEffects() {
    //alert('added');
    const items = document.querySelectorAll("li.grid__item");

    items.forEach(function (item) {
      const media = item.querySelector(".media.jjj");
      if (!media) return;

      const images = media.querySelectorAll("img");
      if (images.length >= 2) {
        const img1 = images[0];
        const img2 = images[1];

        // Reset default states
        img1.style.translate = "none";
        img1.style.rotate = "none";
        img1.style.scale = "none";
        img1.style.transform = "translate(0px, 0px)";

        img2.style.translate = "none";
        img2.style.rotate = "none";
        img2.style.scale = "none";
        img2.style.transform = "translate(125%, 0%)";

        // Hover in
        item.addEventListener("mouseenter", function () {
          img1.style.transform = "translate(-125%, 0%) translate3d(0px, 0px, 0px)";
          img2.style.transform = "translate(0px, 0px)";
        });

        // Hover out
        item.addEventListener("mouseleave", function () {
          img1.style.transform = "translate(0px, 0px)";
          img2.style.transform = "translate(125%, 0%)";
        });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Run once on first load
    setupGridHoverEffects();

    // Run again after each Barba transition
    if (window.barba) {
      barba.hooks.after(() => {
        setupGridHoverEffects();
      });
    }
  });

